<template>
  <button
    class="app-button"
    :class="`--${theme}`"
    :style="{
      'height': `${height}px`,
      'max-width': `${maxWidth}px`
    }"
    @click="$emit('clicked')"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: 'button'
    }, // 表示するラベル
    theme: {
      type: String,
      required: false,
      default: 'black',
      validator: (value) => {
        return ['red', 'white', 'gray', 'pale-white', 'black'].includes(value)
      }
    }, // カラーテーマ
    maxWidth: {
      type: Number,
      required: false,
      default: 320
    }, // ボタンの最大幅
    height: {
      type: Number,
      required: false,
      default: 48
    } // ボタンの高さ
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.app-button {
  border-radius: .25rem;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
  width: 100%;

  @include hover {
    opacity: .8;
  }

  &.--red {
    background-color: $red;
    color: $white;
  }

  &.--white {
    background-color: $white;
    border: 2px solid $black;
    color: $black;
  }

  &.--gray {
    background-color: $cool-gray-4;
    color: $black;
  }

  &.--pale-white {
    background-color: $white;
    border: 1px solid $cool-gray-4;
    color: $black;
    font-weight: normal;
  }

  &.--black {
    background-color: $black;
    color: $white;
  }
}
</style>
